import cn from "classnames";
import { useTranslation } from "react-i18next";
import FilterDatePicker from "./FilterDatePicker";

import "./filterDateRange.scss";
import { type Filter, type DateRange } from "features/AssetResults/types";

export type FilterDateRangeProps = {
  label?: string;
  filter: Filter;
  filterDateValues: DateRange;
  updateFilter: (filter: Filter, newValue: any) => void;
  className?: string;
  disabled?: boolean;
  verticalPosition?: "top" | "bottom";
  horizontalPositionFirstPicker?: "auto" | "left" | "right";
  horizontalPositionSecondPicker?: "auto" | "left" | "right";
};

const FilterDateRange: React.FC<FilterDateRangeProps> = ({
  label,
  filter,
  filterDateValues,
  updateFilter,
  className,
  disabled,
  verticalPosition,
  horizontalPositionFirstPicker,
  horizontalPositionSecondPicker,
}) => {
  const { t } = useTranslation(["account"]);

  return (
    <div className={cn("filter-date-range", className)}>
      {label && <div className="label">{label}</div>}
      <div className="bottom-row">
        <FilterDatePicker
          placeholder={t("myHistory.from")}
          filterDateValues={filterDateValues.from}
          className="left"
          filter={filter}
          updateFilter={updateFilter}
          disabled={disabled}
          verticalPosition={verticalPosition}
          horizontalPosition={horizontalPositionFirstPicker}
          maxDate={filterDateValues.to}
        />
        <FilterDatePicker
          placeholder={t("myHistory.to")}
          filterDateValues={filterDateValues.to}
          className="right"
          filter={filter}
          updateFilter={updateFilter}
          disabled={disabled}
          verticalPosition={verticalPosition}
          horizontalPosition={horizontalPositionSecondPicker}
          popupPosition="bottom right"
          minDate={filterDateValues.from}
        />
      </div>
    </div>
  );
};

export default FilterDateRange;
